module.exports = __webpack_public_path__ + "static/media/border.3516e77b.png";